import type { ReactNode, CSSProperties } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@perch/ui-tokens';

const cardVariants = cva(
  'bg-white dark:bg-stone-900 border border-stone-200 dark:border-stone-700',
  {
    variants: {
      variant: {
        standard: 'rounded-[20px] p-6',
        compact: 'rounded-[14px] p-4',
        stat: 'rounded-xl p-4',
        premium: 'rounded-[20px] p-8 border-[1.5px] border-[#FF6B35]',
      },
      hoverable: {
        true: 'hover:border-stone-300 dark:hover:border-stone-600 hover:-translate-y-0.5 hover:shadow-[0_4px_12px_rgba(28,25,23,0.06)] dark:hover:shadow-[0_4px_12px_rgba(0,0,0,0.3)] transition-[border-color,transform,box-shadow] duration-300 ease-out cursor-pointer',
        false: '',
      },
    },
    defaultVariants: {
      variant: 'standard',
      hoverable: false,
    },
  }
);

interface CardProps extends VariantProps<typeof cardVariants> {
  children: ReactNode;
  className?: string;
  noPadding?: boolean;
  onClick?: () => void;
  style?: CSSProperties;
}

export function Card({
  children,
  variant,
  hoverable,
  className,
  noPadding = false,
  onClick,
  style,
}: CardProps) {
  return (
    <div
      className={cn(
        cardVariants({ variant, hoverable: hoverable ?? !!onClick }),
        noPadding && '!p-0',
        className,
      )}
      onClick={onClick}
      style={style}
    >
      {children}
    </div>
  );
}

export { cardVariants };
